/**
 *
 * Login
 *
 */

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import { Button, Text } from 'components/common';
import HomeIllustration from 'assets/images/home.png';
import { CustomLoginError } from 'components';

import {
  DEFAULT_AUTH0_CONNECTION,
  PRODIGAL_LOGO_LIGHT,
  ERROR_MESSAGE_PARAM,
  UNEXPECTED_LOGIN_ERROR,
} from 'utils/commonConstants';
import Auth from 'auth0-react';

import styles from './style.module.css';

export const auth = new Auth();

export function Login() {
  const { loginWithRedirect, isLoading } = useAuth0();
  const location = useLocation();
  const [loginError, setLoginError] = React.useState<string>('');

  const handleLogin = () => {
    // Auth0 Universal Login will handle SSO routing automatically
    // NOTE: If we prompt the user to always login - the SSO users will need to authenticate (enter IdP credentials) each time they login to the app. That is why `prompt: 'login'` is disabled and we let Auth0 decide if the user needs to login or not.
    loginWithRedirect({
      authorizationParams: {
        connection: DEFAULT_AUTH0_CONNECTION,
        // prompt: 'login',
      },
    });
  };

  useEffect(() => {
    try {
      const searchQuery = new URLSearchParams(location.search);
      const errorMessageParam = searchQuery.get(ERROR_MESSAGE_PARAM);
      if (errorMessageParam) {
        setLoginError(decodeURIComponent(errorMessageParam));
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.loginHolder}>
        <div className={styles.leftPane}>
          <div className={styles.logoHolder}>
            <Text type="title" text="Welcome to" />
            <img
              src={PRODIGAL_LOGO_LIGHT}
              className={styles.logoImg}
              alt="Logo"
              title="Prodigal"
            />
          </div>
          <div className={styles.loginForm}>
            <p className={styles.errorText}>
              {loginError === UNEXPECTED_LOGIN_ERROR ? (
                <CustomLoginError />
              ) : (
                loginError
              )}
            </p>
            <Button
              loading={isLoading}
              type="primary"
              height="50px"
              onClick={handleLogin}
              text="LogIn"
              texttransform="uppercase"
            />
          </div>
        </div>
        <div className={styles.rightPane}>
          <img className={styles.illustration} src={HomeIllustration} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Login;
